import React from 'react'

import EffectuationError from '~/components/organisms/EffectuationError'

import { WizardInputInterface } from '~/models/interfaces/components/Wizard'

const Error = () => {
  const wizardElements: WizardInputInterface[] = [
    {
      title: 'Seleção tipo de negociação',
    },
    {
      title: 'Seleção de contratos',
    },
    {
      title: 'Efetivação',
    },
    {
      title: 'Geração de boletos',
      active: true,
    },
  ]

  return (
    <EffectuationError
      title="Erro - Renegociação"
      wizardElements={wizardElements}
    />
  )
}

export default Error
